export const currencyToSymbol = (currencyString: string | undefined): string => {
    const currencyMap: { [key: string]: string } = {
      EUR: "€",
      USD: "$",
      GBP: "£",
    };
    return currencyString
      ? currencyMap[currencyString.toUpperCase()] || currencyString
      : "";
  };

  export const formatAmount = (amount: number): String => {
    const euros = (amount / 100).toFixed(2);
    const [integerPart, decimalPart] = euros.split(".");
    const formattedIntegerPart = integerPart.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      " "
    );
    return `${formattedIntegerPart},${decimalPart}`;
  };